import React from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import RawHTML from "../../RawHTML";
import styles from "./styles.less";

const ContactUsConfirmation = ({ titles }) => {
  return (
    <div className={styles.confirmationWrapper}>
      <Icon className={styles.confirmIcon} name="check circle" size="big" />
      <RawHTML
        className={styles.confirmText}
        html={titles.YourMessageSuccessfulySent}
      />
    </div>
  );
};

ContactUsConfirmation.propTypes = {
  titles: PropTypes.object
};

export default ContactUsConfirmation;



// WEBPACK FOOTER //
// ./src/components/common/ContactUs/ContactUsConfirmation/ContactUsConfirmation.js